import { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useDispatch } from 'react-redux';

import { openNotification } from '../Notification/Notification';
import './PopupWindow.scss';
import * as CONST from './Const';
import {
  setExternalWindow,
  unsetExternalWindow,
} from '../../../store/actions/netbatchJobs/netbatchJobs';

const PopupWindow = props => {
  const dispatch = useDispatch();
  const [containerEl] = useState(document.createElement('div'));
  containerEl.classList.add('portal-container');
  let externalWindow = null;

  useEffect(() => {
    externalWindow = window.open(
      '',
      '',
      'width=' +
        props.width +
        ',height=' +
        props.height +
        ',left=' +
        props.left +
        ',top=' +
        props.top
    );
    if (!externalWindow) {
      openNotification(
        CONST.NOTIFICATION_MSG,
        CONST.NOTIFICATION_DESC,
        0,
        CONST.BACKGROUND_COLORS.RED
      );
      return;
    }
    copyStyles(document, externalWindow.document);
    externalWindow.document.title = props.title;
    externalWindow.document.body.appendChild(containerEl);
    externalWindow.addEventListener('beforeunload', () => {
      if (externalWindow) externalWindow.close();
    });
    dispatch(setExternalWindow(externalWindow, props.job.Jobid));
    // Created Popup Window
    return function cleanup() {
      externalWindow.close();
      externalWindow = null;
      dispatch(unsetExternalWindow(props.job.Jobid));
      // Cleaned up Popup Window
    };
  }, []);

  function copyStyles(sourceDoc, targetDoc) {
    Array.from(sourceDoc.styleSheets)
      //this line filters out any external css injection by chrome extensions or other sources
      .filter(
        styleSheet =>
          !styleSheet.href || styleSheet.href.startsWith(window.location.origin)
      )
      .forEach(styleSheet => {
        if (styleSheet.cssRules) {
          // for <style> elements
          const newStyleEl = sourceDoc.createElement('style');

          Array.from(styleSheet.cssRules).forEach(cssRule => {
            // write the text of each rule into the body of the style element
            newStyleEl.appendChild(sourceDoc.createTextNode(cssRule.cssText));
          });

          targetDoc.head.appendChild(newStyleEl);
        } else if (styleSheet.href) {
          // for <link> elements loading CSS from a URL
          const newLinkEl = sourceDoc.createElement('link');

          newLinkEl.rel = 'stylesheet';
          newLinkEl.href = styleSheet.href;
          targetDoc.head.appendChild(newLinkEl);
        }
      });
  }

  return ReactDOM.createPortal(props.children, containerEl);
};

export default PopupWindow;
